<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/mint-ui.png" /></div>
      <p>Mint-UI</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = 'https://uedcdn.zto.com/static/mint-ui/'
export default {
  name: 'index',
  data () {
    return {
      fileList: [{
        label: '2.2.13',
        linkList: [
          ur + '2.2.13/index.js',
          ur + '2.2.13/style.css',
          ur + '2.2.13/style.min.css'
        ]
      }, {
        label: '2.2.12',
        linkList: [
          ur + '2.2.12/index.js',
          ur + '2.2.12/style.css',
          ur + '2.2.12/style.min.css'
        ]
      }, {
        label: '2.2.11',
        linkList: [
          ur + '2.2.11/index.js',
          ur + '2.2.11/style.css',
          ur + '2.2.11/style.min.css'
        ]
      }, {
        label: '2.2.10',
        linkList: [
          ur + '2.2.10/index.js',
          ur + '2.2.10/style.css',
          ur + '2.2.10/style.min.css'
        ]
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListMintUi.vue